import { TableHeader } from 'components/UI/V3/Table/Header/TableHeader';
import { TableHeaderCell } from 'components/UI/V3/Table/HeaderCell/TableHeaderCell';
import Checkbox from 'components/UI/V3/Forms/Checkbox';
import { FunctionComponent } from 'react';
import { Sort, SortOrder } from '@spike/model';
import HeaderTableSorter from './HeaderTableSorter';
import { SortOrder as ClientSortOrder } from './sorting';
import { groomingSortColumns } from './groomingSort';
import columnStyles from './HeaderTableColumn.module.scss';
import styles from './GroomingHeaderTable.module.scss';
import clsx from 'clsx';

interface GroomingHeaderTableProps {
    sort: Sort | null;
    onSort?: (sort: Sort) => void;
    allSelected?: boolean;
    onToggleSelectAll?: (checked: boolean) => void;
}

const columns: Array<{ column: string; label: string }> = [
    { column: groomingSortColumns.client, label: 'Client Name' },
    { column: groomingSortColumns.pet, label: 'Pet Name' },
    { column: groomingSortColumns.service, label: 'Service' },
    { column: groomingSortColumns.staff, label: 'Staff' },
    { column: groomingSortColumns.bookedAt, label: 'Date & Time' },
    { column: groomingSortColumns.total, label: 'Total' }
];

export const GroomingHeaderTable: FunctionComponent<GroomingHeaderTableProps> = props => {
    const sortHandler = (column: string) => {
        if (!props.onSort) {
            return;
        }

        if (props.sort?.column === column) {
            props.onSort({
                column,
                order: props.sort.order === SortOrder.ASCENDANT ? SortOrder.DESCENDANT : SortOrder.ASCENDANT
            });
            return;
        }

        props.onSort({ column, order: SortOrder.ASCENDANT });
    };

    return (
        <TableHeader>
            {props.onToggleSelectAll && (
                <TableHeaderCell className={styles.checkboxCell}>
                    <Checkbox
                        checked={props.allSelected}
                        onChange={props.onToggleSelectAll}
                    />
                </TableHeaderCell>
            )}
            {columns.map(column => {
                const selected = props.sort?.column === column.column;

                return (
                    <TableHeaderCell key={column.column}>
                        <div
                            className={clsx(columnStyles.container, columnStyles.sortable)}
                            onClick={() => sortHandler(column.column)}
                        >
                            {column.label}
                            {selected && (
                                <HeaderTableSorter
                                    order={
                                        props.sort?.order === SortOrder.DESCENDANT
                                            ? ClientSortOrder.DESCENDING
                                            : ClientSortOrder.ASCENDING
                                    }
                                />
                            )}
                        </div>
                    </TableHeaderCell>
                );
            })}
        </TableHeader>
    );
};

export default GroomingHeaderTable;
